
















































































import Vue from "vue";
import Api from "../../base/api.typings";
import Component from "vue-class-component";
import documentoService from "./documento-service";
import { obterDataFormatada, isMobile, obterSituacaoDescricao } from "../../utils/utils";
import env from '../../env/env';
import empresaAtualService from "../empresa-atual/empresa-atual-service";
import authService from '../../features/api-authorization/authorize-service'; 
import chamadoService from "../chamado/chamado-service";
import areaService from '../area-atual/area-service';
import servicoService from '../servico/servico-service';

@Component
export default class DocumentoListar extends Vue {
    documento: Api.App.Server.Documentos.ListarDocumentos.ResultadoDto = null;

    areaAtual: string = null;

    get carregando() {
        return !this.documento;
    }

    paginaAtual = 1;

    tamanhoPagina = 8;

    servicoGrupoId = null;

    servicoGrupos: Api.App.Server.Servico.ListarServicoGrupos.Dto[] = [];

    async listaServicosGrupos() {
        let servicoGrupos = await servicoService.listarServicoGrupos({});

        this.servicoGrupos = servicoGrupos.itens;
    }

    obterSituacaoDescricao = obterSituacaoDescricao;

    empresaAtual: string = null;

    async carregarDados() {
        this.areaAtual = await areaService.obterAreaPadrao();
        this.listaServicosGrupos();
    }

    created() {
        this.carregarDados();
        this.obterEmpresaAreaAtual();
        this.listarDocumentos(1);
    }

    obterSituacaoCor(situacao: Api.Common.Domain.ChamadoSituacaoEnum) {
        switch (situacao) {
            case Api.Common.Domain.ChamadoSituacaoEnum.Aberto:
                return "t-chamado-situacao-aberto";
            case Api.Common.Domain.ChamadoSituacaoEnum.Fechado:
                return "t-chamado-situacao-fechado";
            case Api.Common.Domain.ChamadoSituacaoEnum.EmAndamento:
                return "t-chamado-situacao-andamento";
            default:
                break;
        }
    }

    async obterEmpresaAreaAtual() {
        this.empresaAtual = await empresaAtualService.obterEmpresaAtualId();
    }

    async logout() {
        if (this.empresaAtual == null) {
            await authService.signOut({ returnUrl: location.origin });
        }
    }
    
    async listarDocumentos(servicoGrupoId: number) {
        this.documento = await documentoService.listarDocumentos({
            paginaAtual: this.paginaAtual,
            tamanhoPagina: this.tamanhoPagina,
            empresaId: await empresaAtualService.obterEmpresaAtualId(),
            servicoGrupoId: servicoGrupoId
        });
    }

    novaSituacao: Api.Common.Domain.ChamadoSituacaoEnum = Api.Common.Domain.ChamadoSituacaoEnum.Fechado;

    async editarChamado(value) {
        await chamadoService.editarChamado({
            id: this.documento.dto[value].chamadoId,
            atribuidoA: this.documento.dto[value].atribuidoA,
            situacao: this.novaSituacao,
            prioridade: this.documento.dto[value].prioridade,
            empresaId: this.documento.dto[value].empresaId,
        });

        this.$snackbars.open({
            text: "Chamado encerrado",
            color: "primary",
        });

        setTimeout(() => {
            window.location.reload();
        }, 2000);
    }

    async imprimirDocumento(event, documentoId: string) {
        (this.$refs.documentoVisualizar as any).imprimirDocumento(event, documentoId);
    }        

    async alterarPagina(incremento: number) {
        this.paginaAtual += incremento;

        if (this.paginaAtual <= 1)
            this.paginaAtual = 1;

        await this.listarDocumentos(1);
    }

    exibirDocumento(event, documentoId: string, documentoTitulo: string) {
        (this.$refs.documentoVisualizar as any).exibirDocumento(event, documentoId, documentoTitulo);
    }

    exibirChamado(chamadoId: number) {
        (this.$refs.chamadoModal as any).exibirModal(chamadoId);
    }        
}
